import React from "react";
import "./PageNotFound.scss";
const PageNotFound = () => {
  return <div>PageNotFound</div>;
};

export default PageNotFound;
